// Copyright 2026. WebPros International GmbH. All rights reserved.

import styled from 'styled-components';
import { StyledActions } from 'common/components/Actions/Styles';

export const PlanActionsContainer = styled(StyledActions)`
    .pul-dropdown {
        display: none;
    }

    @media (max-width: 1344px) {
        .pul-dropdown {
            display: block;
        }
    }
`;

export const InlineActions = styled.div`
    display: flex;

    @media (max-width: 1344px) {
        display: none;
    }
`;
